import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
// styles
import dibsCss from 'dibs-css';
import styles from './SearchBarTerm.scss';

export const SearchBarTerm = props => {
    const { href, term, handleRowClick, cursorHighlightId, id, termElements } = props;
    const searchBarTermClasses = classnames(styles.hoverBackground, {
        [styles.active]: id === cursorHighlightId,
    });
    const linkClasses = classnames(
        dibsCss.textBodyMediumNormal,
        dibsCss.wFull,
        dibsCss.block,
        styles.linkItem
    );

    return (
        <div className={searchBarTermClasses}>
            <Link
                dataTn="search-bar-term"
                className={linkClasses}
                href={href}
                onClick={e => {
                    e.preventDefault();
                    handleRowClick(term, href, e);
                }}
            >
                {termElements}
            </Link>
        </div>
    );
};

SearchBarTerm.propTypes = {
    term: PropTypes.string,
    termElements: PropTypes.any,
    href: PropTypes.string,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    id: PropTypes.string,
};
